import React from 'react'
import { connect } from 'react-redux'
import { getBySlug } from '@brainstud/react-helpers'
import { setProgress } from '@brainstud/react-tbl/features/quiz/store'
import Summary from './Summary'

class SummaryView extends React.Component {
  componentDidMount() {
    this.props.setProgress(this.props.quiz.id, {
      location: 'summary',
    })
  }

  render() {
    return <Summary {...this.props} />
  }
}

export default connect(
  (state, props) => {
    const navigation = state.navigation.list.byId
    const chapters = state.chapters.chapters.byId
    const quizes = state.quizes.quizes.byId
    const questionsAll = state.quizes.questions.byId
    const progressAll = state.quizes.progress
    const answersAll = state.quizes.answers.byId
    let quiz = {}

    if(props.match.params.chapter) {
      const chapter = getBySlug(chapters, props.match.params.chapter)
      quiz = quizes[chapter.quizId]
    } else {
      const navItem = Object.values(navigation).find(item => item.type === 'quiz')
      quiz = quizes[navItem.quizId]
    }

    const questions = quiz.questions.reduce((acc, item) => {
      return acc.concat({
        ...questionsAll[item],
        progress: progressAll[item],
        answers: questionsAll[item].answers.reduce((acc2, item2) => {
          return acc2.concat(answersAll[item2])
        }, [])
      })
    }, [])

    const progress = progressAll[quiz.id] || {}

    return { quiz, progress, questions }
  },
  (dispatch) => ({
    setProgress: (id, progress) => dispatch(setProgress(id, progress)),
  })
)(SummaryView)
